import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import rootReducer from '@/store/rootReducer';

import type { OnetimeWorkFormSchemaType } from '../components/OnetimeWorkForm';

type RootState = ReturnType<typeof rootReducer>;

interface State {
  /**
   * 일회성 작업 생성/수정 폼 상태
   */
  formData: OnetimeWorkFormSchemaType;
}

export const getInitialFormData = (): State['formData'] => ({
  venue: NaN,
  // tagGroup: NaN,
  // tagName: NaN,
  workName: '',
  content: '',
  floor: NaN,
  spaceCategory: NaN,
  space: NaN,
  operatingHours: NaN,
  isUrgent: false,
  timeBegin: '',
  timeEnd: '',
  willStartTomorrow: false,
  willEndTomorrow: false,
  beginDate: '',
  endDate: '',
  files: [],
});

export const getInitialState = (): State => ({
  formData: getInitialFormData(),
});

const onetimeWorkStore = createSlice({
  name: 'onetimeWork',
  initialState: getInitialState(),
  reducers: {
    /**
     * 일회성 작업 폼 데이터를 업데이트 합니다.
     */
    updateOnetimeWorkForm(
      state,
      { payload }: PayloadAction<Partial<OnetimeWorkFormSchemaType>>
    ) {
      state.formData = { ...state.formData, ...payload };
    },
    /**
     * 일회성 작업 스토어를 초기화합니다.
     */
    initOnetimeWorkForm(state) {
      const formData = getInitialFormData();
      state.formData = { ...formData };
    },
  },
});

export const onetimeWorkFormDataSelector = (state: RootState) =>
  state.onetimeWork.formData;

export const onetimeWorkStoreActions = onetimeWorkStore.actions;

export default onetimeWorkStore.reducer;
